import React from "react";
import {
  Row,
  Table,
  Modal,
  Button,
  Form,
  Input,
  Col,
  notification,
  Divider,
} from "antd";

import axios from "axios";
import { Constant } from "../../../config/index";

import "./style.css";

class AddingCreditModal extends React.Component {
  state = {
    addedCredit: 0,
    remark: "",
    loading: false,
    balance: 0,
    allowSubmit: false,
  };

  componentDidMount() {
    const { data } = this.props;

    this.setState({
      balance: data.memberBalance,
      addedCredit: 0,
      remark: "",
    });
  }

  onChangeBalance = (val) => {
    const float = parseFloat(val);
    this.setState({ addedCredit: float });
  };

  onReset = () => {
    this.setState({ addedCredit: 0, remark: "" });
    this.props.form.resetFields();
  };

  handleKeyDown = (event, callback) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  onSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      if (err) {
        return;
      }

      this.setState({ loading: true });

      const { data } = this.props;
      const url = Constant.MEMBER_ADD_CREDIT_API.replace("[id]", data.memberId);
      const opt = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
        }
      };
      const balance_add = parseFloat(values["balance"]);
      const fd = { balance_add, remark: values["remark"]}
      let resp;

      try {
        resp = await axios.put(url, fd, opt);
      } catch (error) {
        notification.error({
          message: "Server went wrong",
          description: error.response.data,
        });
        return;
      }

      this.props.form.resetFields();

      notification["success"]({
        message: "การเพิ่มเครดิตเสร็จสิ้น",
        description: "",
      });

      this.setState({
        loading: false,
        addedCredit: 0,
        balance: resp.data.balance,
      });
    });
  };

  column = [
    {
      title: "ชื่อ",
      dataIndex: "name",
    },
    {
      title: "จำนวนเงินปัจจุบัน",
      dataIndex: "balance",
    },
    {
      title: "เพิ่มจำนวนเงิน",
      dataIndex: "addedCredit",
      render: (v) => {
        return parseFloat(v).toFixed(4);
      },
    },
    {
      title: "จำนวนเงินทั้งหมด",
      dataIndex: "summaryCredit",
      render: (_, rec) => {
        const total = rec.balance + rec.addedCredit;
        return total.toFixed(4);
      },
    },
  ];

  render() {
    const { visible, data, onCancel } = this.props;
    const { getFieldDecorator } = this.props.form;
    const title = (
      <span>
        Adding Credit's{" "}
        <span style={{ fontWeight: "bold" }}>{data.memberName}</span>
      </span>
    );
    const dataSource = [
      {
        name: data.memberName,
        balance: this.state.balance,
        addedCredit: this.state.addedCredit || 0,
        summaryCredit: data.memberBalance,
      },
    ];

    return (
      <Modal
        title={title}
        visible={visible}
        onCancel={() => onCancel(this.state.balance)}
        width={800}
        footer={null}
      >
        <Table
          bordered
          columns={this.column}
          dataSource={dataSource}
          pagination={false}
        />
        <Divider />
        <Form 
          className="form-adding-credit"
          onKeyDown={this.handleKeyDown}
          onSubmit={this.onSubmit}
          onReset={this.onReset}
        >
          <Form.Item>
            <Row>
              <Col span={6} align="right">จำนวนเงิน :</Col>
              <Col span={18} align="left">
                {getFieldDecorator("balance", {
                  disabled: this.state.loading,
                  rules: [
                    {
                      validator: (rule, value, cb) => {
                        const isNumeric = (v) => /^-?\d*\.?\d*$/.test(v);
                        const hasFourDecimalPlaces = (v) => /^-?\d*\.?\d{0,4}$/.test(v);

                        if (!value) {
                          return Promise.reject("กรุณากรอกจำนวนเงิน");
                        }

                        if (!isNumeric(value)) {
                          return Promise.reject("กรุณากรอกจำนวนเงินเป็นตัวเลขเท่านั้น");
                        }

                        if (!hasFourDecimalPlaces(value)) {
                          return Promise.reject("จำนวนเงินสามารถกรอกเลขทศนิยมได้ไม่เกิน 4 ตัว");
                        }

                        const tmp = parseFloat(value);
                        if (tmp === 0) {
                          return Promise.reject("จำนวนเงินต้องไม่เท่ากับ 0");
                        }

                        this.onChangeBalance(value)

                        return Promise.resolve();
                      },
                    },
                  ],
                })(
                  <Input
                    type="number"
                    placeholder="สามารถใส่จำนวนเงินเป็นจำนวนลบได้ เช่น -10 (ทศนิยมสูงสุด 4 ตัว)"
                    disabled={this.state.loading}
                  />
                )}
              </Col>
            </Row>
          </Form.Item>  
          <Form.Item>
            <Row>
              <Col span={6} align="right">หมายเหตุ :</Col>
              <Col span={18} align="left">
                {getFieldDecorator("remark", {
                  disabled: this.state.loading,
                  rules: [
                    {
                      required: true,
                      message: "กรุณากรอกหมายเหตุ",
                    },
                    {
                      validator: (_, value) => {
                        if (!value) return Promise.resolve();
                        
                        const containsAlphanumeric = /[a-zA-Z0-9\u0E00-\u0E7F]/.test(value);
                        if (!containsAlphanumeric) {
                          return Promise.reject("จะต้องมีตัวอักษรหรือตัวเลขอย่างน้อยหนึ่งตัว");
                        }
                        return Promise.resolve();
                      },
                    },
                  ],
                })(
                  <Input.TextArea
                    placeholder="เหตุผลของการเพิ่ม หรือ ลด จำนวนเงิน"
                    rows={4}
                    onChange={this.onChangeRemark}
                    disabled={this.state.loading}
                  />
                )}
              </Col>
            </Row>
          </Form.Item>
          <Form.Item>
            <Row>
              <Col span={6} align="right"></Col>
              <Col span={18} align="left">
                <Button type="danger" htmlType="reset">Reset</Button>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Col>
            </Row>
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ name: "adding-credit" })(AddingCreditModal);



// WEBPACK FOOTER //
// ./src/containers/User/UserManagement/AddCreditModal.js